import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { memo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { ItemVM } from 'shell/view-models/item';

export interface CustomTypeForList extends ItemVM {
  textValue: string;
}
const list: Readonly<Array<CustomTypeForList>> = Object.freeze([
  {
    id: 1,
    value: 'SUCCESS',
    textValue: 'Se termina correttamente',
  },
  {
    id: 2,
    value: 'ERROR',
    textValue: 'Se termina in errore',
  },
]);

interface SchedulationTypeListProps {
  value: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (type: SelectChangeEvent<string>) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

const EventDropdown = ({
  value,
  disabled,
  onChange,
  required,
  error,
  label = 'Tipo Evento',
  id = 'event',
}: SchedulationTypeListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        label={required ? `${label} *` : label}
        disabled={disabled}
        value={value}
        onChange={onChange}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {list.map((status: CustomTypeForList) => (
          <MenuItem key={status.id} value={status.value}>
            {status.textValue}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

EventDropdown.displayName = 'Event drop-down component of  job';

export const EventJobList = memo(EventDropdown) as typeof EventDropdown;

export default EventJobList;
